import React from "react";
import { NewsletterSubscribe } from "src/components";
import { P } from "src/components/Semantic";
import toaster from "src/lib/toaster";
import {
  footerInteractionTracking,
  subscribeToAlertTracking,
} from "src/services/analytics.service";
import { translate } from "src/services/translation.service";
import theme, { media } from "src/theme";
import styled from "styled-components";

import SectionFooter from "../SectionFooter";

const Subtitle = styled(P)`
  font-size: 14px;
  text-align: center;
  margin-top: ${theme.margins.marginBase};

  ${media.laptop} {
    text-align: left;
    order: 1;
  }
`;

const SocialNetwork = styled.div`
  ${media.laptop} {
    order: 2;

    article ul {
      justify-content: flex-start;
    }
  }
`;

export interface IProps {
  renderSocial?: JSX.Element;
}

export const Newsletter = ({ renderSocial }: IProps): JSX.Element => {
  return (
    <SectionFooter title={translate("footer.getNewsletter")}>
      <Subtitle>{translate("footer.subscribeToNewsletter")}</Subtitle>
      <NewsletterSubscribe
        onGuestSubscribe={({ guestNewsletterSubscribe }): void => {
          const { message } = guestNewsletterSubscribe;

          if (message) {
            toaster.notify(message);
          } else {
            toaster.notify("Unknown error");
          }

          subscribeToAlertTracking("newsletter");
          footerInteractionTracking("newsletter");
        }}
        onUserSubscribe={(): void => {
          toaster.notify(translate("toaster.registrationRequestRegistered"));
          subscribeToAlertTracking("newsletter");
          footerInteractionTracking("newsletter");
        }}
      />
      <SocialNetwork>{renderSocial}</SocialNetwork>
    </SectionFooter>
  );
};
